import React from "react";
import { Alert } from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";
import BonusForm from "./utilities/BonusForm";
import BonusTable from "./utilities/BonusTable";
import DeletionConfirmationModal from "./utilities/DeletionConfirmationModal";
import DisableConfirmationModal from "./utilities/DisableConfirmationModal";
import EditBonusModal from "./utilities/EditBonusModal"; // Nouveau import
import useBonusData from "./utilities/useBonusData";

const AssignBonus = (props) => {
  const {
    employee,
    isLoading,
    isSaving,
    isDeleting,
    isDisabling,
    isUpdating, // Nouveau état
    successMessage,
    backendError,
    totalBonuses,
    assignedBonuses,
    allBonuses,
    selectedBonus,
    setSelectedBonus,
    customAmount,
    setCustomAmount,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    isTaxable,
    setIsTaxable,
    currentBonus,
    handleSubmit,
    handleRemoveBonus,
    handleDisableBonus,
    openDeleteModal,
    closeDeleteModal,
    showDeleteModal,
    bonusToDelete,
    openDisableModal,
    closeDisableModal,
    showDisableModal,
    bonusToDisable,
    clearForm,
    tableData,
    bonusColumns,
    isBonusAlreadyAssigned,
    
    // Nouveaux props pour la modification
    openEditModal,
    closeEditModal,
    showEditModal,
    bonusToEdit,
    editAmount,
    setEditAmount,
    editStartDate,
    setEditStartDate,
    editEndDate,
    setEditEndDate,
    editIsTaxable,
    setEditIsTaxable,
    handleUpdateBonus,
  } = useBonusData();
  
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading data...</p>
        </div>
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="text-center p-5">
        <div className="alert alert-warning">
          <i className="fa fa-exclamation-triangle fa-2x mb-3"></i>
          <h5>{props.t("employee_not_found")}</h5>
          <p>{props.t("cannot_find_employee")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="patients-list-content">
      <div className="patients-list px-2 pb-5">
        <div className="container-fluid">

          {/* Header */}
          <div className="heading-parent-sec">
            <div className="heading-parent-sec d-flex align-items-center pt-4">
              {/* Bouton retour */}
              <button
                onClick={() => navigate(-1)}
                className="btn btn-link p-0 me-3"
                style={{ textDecoration: "none", color: "#0d6efd" }}
              >
               <h6> {props.t("staff_management")}</h6>
              </button>
              <h6><span style={{ fontWeight: "bold" }}> /&nbsp; </span> {props.t("assign_bonuses")} - {employee.fullName}</h6>
            </div>
          </div>

          {/* Messages d'alerte */}
          <div className="mt-3">
            {successMessage && (
              <Alert color="success" className="alert-dismissible">
                <i className="fa fa-check-circle me-2"></i>
                {successMessage}
              </Alert>
            )}
            {backendError && (
              <Alert color="danger" className="alert-dismissible">
                <i className="fa fa-exclamation-circle me-2"></i>
                {backendError}
              </Alert>
            )}
            {allBonuses.length === 0 && assignedBonuses.length > 0 && (
              <Alert color="warning" className="alert-dismissible">
                <i className="fa fa-info-circle me-2"></i>
                 {props.t("All_bonuses_are_assigned")}
              </Alert>
            )}
            {allBonuses.length === 0 && assignedBonuses.length === 0 && (
              <Alert color="info" className="alert-dismissible">
                <i className="fa fa-info-circle me-2"></i>
                {props.t("no_availble_bonuses")}
              </Alert>
            )}
          </div>

          {/* Bonus Form */}
          {allBonuses.length > 0 && (
            <BonusForm
              allBonuses={allBonuses}
              selectedBonus={selectedBonus}
              setSelectedBonus={setSelectedBonus}
              customAmount={customAmount}
              setCustomAmount={setCustomAmount}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              isTaxable={isTaxable}
              setIsTaxable={setIsTaxable}
              currentBonus={currentBonus}
              handleSave={handleSubmit}
              isSaving={isSaving}
              backendError={backendError}
              isBonusAlreadyAssigned={isBonusAlreadyAssigned}
            />
          )}

          {/* Bonus Table */}
          <BonusTable
            tableData={tableData}
            bonusColumns={bonusColumns}
            assignedBonuses={assignedBonuses}
            openDeleteModal={openDeleteModal}
            openDisableModal={openDisableModal}
            openEditModal={openEditModal} // Nouveau prop
            handleDisableBonus={handleDisableBonus}
            isDeleting={isDeleting}
            isDisabling={isDisabling}
            isUpdating={isUpdating} // Nouveau prop
          />

          {/* Modal de confirmation de suppression */}
          <DeletionConfirmationModal
            isOpen={showDeleteModal}
            toggle={closeDeleteModal}
            onConfirm={handleRemoveBonus}
            isDeleting={isDeleting}
            bonusToDelete={bonusToDelete}
            type="bonus"
          />

          {/* Modal de confirmation de disable */}
          <DisableConfirmationModal
            isOpen={showDisableModal}
            toggle={closeDisableModal}
            onConfirm={handleDisableBonus}
            isDisabling={isDisabling}
            bonusToDisable={bonusToDisable}
            type="bonus"
          />

          {/* Modal de modification*/}
          <EditBonusModal
            isOpen={showEditModal}
            toggle={closeEditModal}
            onConfirm={handleUpdateBonus}
            isUpdating={isUpdating}
            bonusToEdit={bonusToEdit}
            editAmount={editAmount}
            setEditAmount={setEditAmount}
            editStartDate={editStartDate}
            setEditStartDate={setEditStartDate}
            editEndDate={editEndDate}
            setEditEndDate={setEditEndDate}
            editIsTaxable={editIsTaxable}
            setEditIsTaxable={setEditIsTaxable}
            backendError={backendError}
          />

        </div>
      </div>
    </div>
  );
};

export default withRouter(withTranslation()(AssignBonus));